import * as Immutable from 'immutable';
import {
  LIST_ADMINUSERS_REQUESTED,
  LIST_ADMINUSERS_COMPLETED,
  LIST_ADMINUSERS_FAILED,
} from '../../actions/adminusers/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_ADMINUSERS_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('gettingdata', true);

    case LIST_ADMINUSERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case LIST_ADMINUSERS_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
